'use strict';

function applyParseOptions(target) {
  // PARSERS

  /**
   * @prop {boolean} [parse.manifest=false]
   * If true the plugin will look for location value in manifest header to retrieve the actual resource,
   * will parse HLS files to use the first .ts file found as resource and
   * will look for location and segment values inside DASH manifest to retrieve the actual resource
   * It might slow performance down.
   */
  target['parse.manifest'] = false;

  /**
   * @prop {boolean} [parse.cdnParser.get=false]
   * If true, the plugin will make a GET request to the CDN resource in order to retrieve the chunk headers
   * instead of using a HEAD request by default.
   */
  target['parse.cdnParser.get'] = false;

  /**
   * @prop {boolean} [parse.manifest.lastChunk=false]
   * If true, when parsing manifests (HLS/DASH), the plugin will check the last chunk file instead
   * of the first chunk file. This is useful when the first chunk might be expired.
   * Only applies when parse.manifest is enabled.
   */
  target['parse.manifest.lastChunk'] = false;

  /**
   * @prop {boolean} [parse.locationHeader.get=false]
   * If true, the plugin will make a GET request to the media resource in order to retrieve the location header,
   * instead of using a HEAD request by default.
   */
  target['parse.locationHeader.get'] = false;

  /**
   * @prop {object} [parse.manifest.auth={}]
   * If parse.manifest enabled, it adds extra headers to the request of the content.
   * Use this if for example, the player needs to include authentication headers to request the content,
   * so the plugin needs it to access to the manifest files too.
   */
  target['parse.manifest.auth'] = {};

  /**
   * @prop {array<string>} [parse.CdnNameHeader]
   * If defined, resource parse will try to fetch the CDN code from the custom header defined
   * by this property. ie: '[x-cdn-forward]'
   */
  target['parse.cdnNameHeader'] = ['x-cdn-forward'];

  /**
   * @prop {string} [parse.CdnNodeHeader]
   * If defined, resource parse will try to fetch the CDN node name from the custom header defined
   * by this property. ie: 'x-node'
   */
  target['parse.cdnNodeHeader'] = '';

  /**
   * @prop {boolean} [parse.CdnNode=false]
   * If true the plugin will query the CDN to retrieve the node name.
   * It might slow performance down.
   */
  target['parse.cdnNode'] = false;

  /**
   * @prop {array<string>} [parse.CdnNode.list=false]
   * If true the plugin will query the CDN to retrieve the node name.
   * It might slow performance down.
   */
  target['parse.cdnNode.list'] = [
    'Akamai',
    'Amazon',
    'Cloudfront',
    'Level3',
    'Fastly',
    'Highwinds',
    'Telefonica',
    'Edgecast',
    'NosOtt'
  ];

  /**
   * @prop {function} [parse.fdsResponseHost=null]
   * Parses fastdata response to modify the host where the requests will be sent
   */
  target['parse.fdsResponseHost'] = undefined;

  /**
   * @prop {function} [parse.cdnSwitchHeader=false]
   * Parses a video chunk or manifest every x seconds to read the x-cdn header and report it
   */
  target['parse.cdnSwitchHeader'] = false;

  /**
   * @prop {function} [parse.cdnTTL=60]
   * if parse.cdnSwitchHeader enabled, the time between new requests
   */
  target['parse.cdnTTL'] = 60;
}

module.exports = applyParseOptions;

